/**
 * @desc: 发送消息组件
 * */
import React from "react";
import ReactDOM from "react-dom";
import "./mobile-send.scss";
import Toast from "@/components/toast/toast";
import { confirmPlatfrom, postMessageData, ApiUri, request } from "@/helper";
import lottie from "lottie-web";
import classNames from "classnames";
import { v4 as uuidV4 } from "uuid";
import * as Event from "@/event/message_events";
import { sendMessage, sendLog } from "@/api/index";

const ENTER_KEYCODE = 13;
let animationStart, animationIdel, animationStop;

export default class MobileSend extends React.Component {
  constructor(props) {
    super(props);
    const data = this.props.data;
    this.state = {
      placeholder:
        confirmPlatfrom() === "ios" ? "输入文字或切换语音" : "输入文字",
      editing: false,
      selecting: false,
      recording: false,
      audioUrl: "",
      recordMode: false,
      recordMsg: "按住说话",
      toastTip: "向上滑动，取消发送",
      startY: 0, //发送语音触摸点初始Y坐标（移动端专用）
      currentVoiceId: null,
      duration: null, //录音时长
      showRecordIcon: true, //是否显示toast icon
      willCancel: false,
    };
    this.timer = null;
    this.enterKeyDown = this.enterKeyDown.bind(this);
  }
  enterKeyDown(e) {
    if (e.keyCode === ENTER_KEYCODE) {
      this.sendTextMessage();
      e.target.blur();
    }
  }
  render() {
    const data = this.props.data;
    const {
      recordMsg,
      recordMode,
      editing,
      placeholder,
      recording,
      toastTip,
      duration,
      showRecordIcon,
      willCancel,
    } = this.state;
    let showRecord = true; //判断iOS原生是否提供录音方法
    if (
      confirmPlatfrom() === "ios" &&
      !window.webkit.messageHandlers.startIMAudioRecord
    ) {
      showRecord = false;
      this.setState({
        placeholder: "请输入文字",
      });
    }
    return (
      <React.Fragment>
        <div className="mobile-sd-wrapper">
          {/* 输入框 */}
          <div className={recordMode ? "hide" : "keyboard-mode"}>
            {confirmPlatfrom() === "ios" && (
              <div
                className={showRecord ? "isSendAudio" : "isSendAudio hide"}
                onClick={(e) => this.showRecord(e)}
              />
            )}
            <input
              className={editing ? "sd-input editing" : "sd-input"}
              contentEditable={true}
              onKeyDown={this.enterKeyDown}
              placeholder={placeholder}
              ref="editNode"
            />
            <div
              className="sd-send-btn"
              onClick={(e) => this.sendTextMessage()}
            >
              发送
            </div>
          </div>
          {/* 输入框_end */}
          {/* 录音 */}
          <div className={recordMode ? "record-mode" : "hide"}>
            <div className={recording ? "tip-toast" : "hide"}>
              <p
                className={classNames("record-upper-tip", {
                  "will-cancel-tip": willCancel,
                })}
              >
                {toastTip}
              </p>
              <div className="ani-box"></div>
              <i
                className={classNames("short-icon record-icon", {
                  hide: showRecordIcon,
                })}
              />
              <p className="duration">{duration && `${duration}S`}</p>
            </div>
            <div
              className="keyboard-btn"
              onClick={(e) => this.returnKeyboardMode(e)}
            />
            <div
              className={recording ? "record-bar active" : "record-bar"}
              onTouchEnd={(e) => this.mobileStopRecord(e)}
              onTouchCancel={(e) => this.mobileCancelRecord(e)}
              onTouchStart={(e) => this.mobileStartRecord(e)}
              onTouchMove={(e) => this.touchMoving(e)}
            >
              {recordMsg}
            </div>
          </div>
          {/* 录音_end */}
        </div>
      </React.Fragment>
    );
  }
  componentDidMount() {
    this._bindEvent(this.refs.editNode);
    document
      .querySelector(".record-bar")
      .addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });
  }
  touchMoving(e) {
    const startY = this.state.startY;
    const endY = e.changedTouches[0].clientY;
    const diff = startY - endY;
    if (diff > 50 && !animationStop) {
      animationIdel && animationIdel.destroy();
      let ele = document.querySelector(".ani-box");
      animationStop = lottie.loadAnimation({
        container: ele,
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: "https://m.xiguacity.cn/xigua-im/im_test/end.json",
      });
    }
    this.setState({
      toastTip: diff > 50 ? "松开手指，取消发送" : "向上滑动，取消发送",
      willCancel: diff > 50,
    });
  }
  mobileStartRecord(e) {
    // showRecordIcon为true意思是不显示❗️icon（没有开始录）,此处取反，在开始录制
    if (!this.state.showRecordIcon) {
      return;
    }
    this.resetRecordUI();
    if (this.state.recording) return;
    Event.bus.emit(Event.PLAYFINISH, null);
    let eventObj = e;
    this.setState({
      startY: eventObj.targetTouches[0].clientY,
    });
    if (window.bridge) {
      window.bridge.startIMAudioRecord({
        params: {},
        success: (succParam) => {
          if (confirmPlatfrom() === "ios") {
            succParam = JSON.parse(succParam);
          }
          console.log("start_succParam:", succParam);
          this.setState({
            recording: true,
            currentVoiceId: succParam.id,
            recordMsg: "松开停止",
          });
          let ele = document.querySelector(".ani-box");
          animationStart = lottie.loadAnimation({
            container: ele,
            renderer: "svg",
            loop: false,
            autoplay: true,
            path: "https://m.xiguacity.cn/xigua-im/im_test/start.json",
          });
          animationStart.addEventListener("complete", () => {
            animationStart.destroy();
            animationIdel = lottie.loadAnimation({
              container: ele,
              renderer: "svg",
              loop: true,
              autoplay: true,
              path: "https://m.xiguacity.cn/xigua-im/im_test/idel.json",
            });
          });
          clearInterval(this.timer);
          this.timer = setInterval(() => {
            this.setState({
              duration: ++this.state.duration,
            });
            if (this.state.duration > 59) {
              this.sendAudioFunc();
              this.resetRecorder();
            }
          }, 1000);
        },
        fail: (failParam) => {
          clearInterval(this.timer);
          if (confirmPlatfrom() === "ios") {
            failParam = JSON.parse(failParam);
          }
          console.log("start_failParam：", failParam);
          let code = Number(failParam.code);
          if (code === 300) {
            this.addToast("启动录音失败", 2000);
          } else if (code === 301) {
            this.addToast("上一个录音尚未结束", 2000);
          } else if (code === 400) {
            this.addToast("权限获取失败", 2000);
          }
        },
      });
    }
  }
  mobileStopRecord(e) {
    this.resetRecordUI();
    if (!this.state.showRecordIcon) {
      return;
    }
    const endY = e.changedTouches[0].clientY;
    const { duration, startY, currentVoiceId } = this.state;
    //录音时长不足0.5s时（实际以1s为判断）
    if (duration < 1) {
      this.setState({
        toastTip: "讲话时间太短",
        duration: null,
        showRecordIcon: false,
        recordMsg: "按住说话",
        willCancel: false,
      });
      window.bridge &&
        window.bridge.cancelIMAudioRecord({
          params: {
            id: currentVoiceId,
          },
          success: () => {},
          fail: () => {},
        });
      clearInterval(this.timer);
      setTimeout(() => {
        this.resetRecorder();
      }, 1000);
      return;
    }
    //发送
    if (endY && startY && startY - endY < 50) {
      this.sendAudioFunc();
    } else {
      //取消发送
      this.setState({
        audioUrl: null,
      });
      this.mobileCancelRecord();
    }
    this.resetRecorder();
  }
  //发送语音
  sendAudioFunc() {
    const { duration, currentVoiceId } = this.state;
    this.props.$updateMessage({
      message: {
        message_type: "loading",
        fromMe: true,
        voiceId: currentVoiceId,
      },
    });
    window.bridge &&
      window.bridge.completeIMAudioRecord({
        params: { id: currentVoiceId },
        success: (succParam) => {
          if (confirmPlatfrom() === "ios") {
            succParam = JSON.parse(succParam);
          }
          console.log("complete_succParam:", succParam);
          const newMessage = {
            message: {
              file_length: duration,
              message_content_type: "audio",
              message: "",
              fromMe: true,
              voiceId: currentVoiceId,
              content: succParam.url,
            },
          };
          this.sendAudioMessage(succParam.url, newMessage.message);
        },
        fail: (failParam) => {
          console.log("complete_failParam:", failParam);
          if (confirmPlatfrom() === "ios") {
            failParam = JSON.parse(failParam);
          }
          if (failParam.code === 400) {
            const newMessage = {
              data: {
                message: {
                  message_type: "failure",
                  message_content_type: "failure",
                  message: "",
                  fromMe: true,
                  voiceId: failParam.id,
                  messageId: uuidV4(),
                  content: "",
                  file_length: failParam.duration,
                },
              },
            };
            this.props.$updateMessage(newMessage.data);
          }
        },
      });
  }
  returnKeyboardMode() {
    this.setState(
      {
        recordMode: false,
      },
      () => {
        this.refs.editNode.focus();
        window.setTimeout(this.scrollBottom, 500);
      }
    );
  }
  scrollBottom() {
    const dl = document.querySelector("#dl-wrapper");
    dl && window.scrollTo(0, dl.clientHeight);
  }
  showRecord() {
    this.setState({
      recordMode: true,
    });
  }
  // 重置录音状态
  resetRecorder() {
    this.setState({
      recordMsg: "按住说话",
      toastTip: "向上滑动，取消发送",
      recording: false,
      duration: null,
      willCancel: false,
      showRecordIcon: true,
    });
    animationStop = null;
    clearInterval(this.timer);
  }
  mobileCancelRecord() {
    if (window.bridge) {
      window.bridge.cancelIMAudioRecord({
        params: { id: this.state.currentVoiceId },
        success: () => {},
        fail: () => {},
      });
    }
  }
  // 绑定事件
  _bindEvent(node) {
    node.addEventListener("focus", (e) => {
      this.setState({
        editing: true,
      });
      this.scrollBottom();
    });
    node.addEventListener("blur", (e) => {
      if (node.innerHTML === "") {
        this.setState({
          editing: false,
        });
      }
    });
  }

  formData(content, data, type, message) {
    const postData = postMessageData(data, {
      message: content,
      message_content_type: type,
      file_length: message && message.file_length,
    });
    return postData;
  }
  resetRecordUI() {
    animationStart && animationStart.destroy();
    animationIdel && animationIdel.destroy();
    animationStop && animationStop.destroy();
    // this.setState({
    //   showRecordIcon: true
    // });
  }
  //发送消息
  sendMessage(content, type, cb, message) {
    const { data, $updateMessage } = this.props;
    const formData = this.formData(content, data, type, message);
    this.ajaxSendMessage(formData, type)
      .then((res) => {
        type === "audio" && (res.message.voiceId = message.voiceId);
        console.log(res.message.voiceId);
        // 更新消息列表
        $updateMessage(res);
        cb && cb.apply(null, ["success", res.message, $updateMessage]);
      })
      .catch((e) => {
        sendLog(formData);
        console.error(`发送消息失败：${e}`);
        cb && cb.apply(null, ["error", { content }, $updateMessage]);
      });
  }

  // 发送语音消息
  sendAudioMessage(content, data) {
    const { methods } = this.props;
    const cb = methods && methods.sendAudio;
    return new Promise(() => {
      this.sendMessage(content, "audio", cb, data);
    });
  }

  // 发送文本消息
  sendTextMessage() {
    const node = this.refs.editNode;
    const { methods } = this.props;
    const content = node.value;
    if (!content.trim()) {
      return;
    }
    const cb = methods && methods.sendText;
    const isEmpty = false;
    this.sendMessage(content, "text", cb);
    // 清空输入框
    if (!isEmpty) {
      node.value = "";
      this.setState({
        editing: false,
      });
    }
  }

  addToast(content, duration) {
    let toastDiv = document.createElement("div");
    let div = document.querySelector(".dl-wrapper");
    if (!div) return;
    div.appendChild(toastDiv);
    ReactDOM.render(<Toast content={content} />, toastDiv);

    this.timer = setTimeout(() => {
      ReactDOM.unmountComponentAtNode(toastDiv);
      div.removeChild(toastDiv);
    }, duration);
  }

  // 检测文本框是否含有 html 标签
  checkIncludeTag(content) {
    return content && /\<[^>]+\>/.test(content);
  }

  // ajax发送消息
  ajaxSendMessage(formData) {
    return new Promise((resolve, reject) => {
      sendMessage(formData)
        .then((res) => {
          const result = {
            online: res.online,
            message: res,
          };
          resolve(result);
        })
        .catch(reject);
    });

    // return new Promise((resolve, reject) => {
    //   Axios.post(ApiUri.MESSAGES, formData)
    //     .then(res => {
    //       if (res.status === 200) {
    //         resolve(res);
    //       } else {
    //         reject(res);
    //       }
    //     })
    //     .catch((err, msg) => {
    //       reject(err, msg);
    //     });
    // });
  }
}
